<template>
  <div class="header-outer">
    <a href="/">
      <img class="header-logo-img" src="../assets/images/logo.png"/>
    </a>
    <a href="/" v-for="(module, index) in modules" :key="index">
      <div :class="module.cls" class="header-module">{{module.content}}</div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        modules: [
          {
            content: '联系我们',
            cls: ''
          },
          {
            content: '成功案例',
            cls: ''
          },
          {
            content: '涉猎领域',
            cls: ''
          },
          {
            content: '官网首页',
            cls: 'header-module-active'
          }
        ]
      }
    },

    methods: {
      selectHandle () {

      }
    }
  }
</script>

<style scoped>
  .header-outer {
    padding-top: 1.98vw;
    padding-right: 2.60vw;
    padding-bottom: 1.56vw;
  }

  .header-logo-img {
    width: 16.04vw;
    height: 3.54vw;
    margin-left: 5.21vw;
  }

  .header-module {
    float: right;
    font-family: PingFangSC-Medium;
    font-size: 1.15vw;
    color: #333333;
    width: 8.54vw;
    height: 2.81vw;
    line-height: 2.81vw;
    margin-left: 1.36vw;
    margin-right: 1.36vw;
    margin-top: 0.365vw;
    text-align: center;
    letter-spacing: 0.094vw;
  }

  .header-module-active {
    color: #fff;
    background-color: #1158E8;
    border-radius: 1.69vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue